import React, { useMemo, useState } from 'react'
import { Dialog, Grid, Input } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import { Edit } from '@material-ui/icons'
import Paper from '@material-ui/core/Paper'
import { ContainerTitle } from '../../../../../../common/container-title'
import { AddItemButtons } from '../../../../../../conventions-collectives/themes/add-item-buttons'
import { ParamDataPopperContent } from './param-data-popper-content'
import InputLabel from '@material-ui/core/InputLabel'
import { PopoverDraggable } from './popover-draggable'
import fonctionModule from '../../../../../../../store/reducers/fonction/fonction-reducer'
import { useSelector } from 'react-redux'

function getOffset(el) {
  const rect = el.getBoundingClientRect()
  return {
    x: rect.left + window.scrollX,
    y: rect.top + window.scrollY,
  }
}

export const getFonctionAsSTR = optionalParams => {
  console.log('fonctionValue', optionalParams)
  if (!optionalParams) return ''
  let key = optionalParams.fonction
  let params = Object.entries(optionalParams.params)
    .map(([k, v]) => k + '=' + getValueAsString(v))
    .reduce((acc, curr) => acc + (acc ? ', ' : '') + curr, '')
  return key + '(' + params + ')'
}

const getValueAsString = (paramValue, currentCC, curentTheme) => {
  if (!paramValue) return ''
  if (paramValue.textValue) {
    const prefix = paramValue.origin === 'VARIBALE_CLIENT' ? '$' : paramValue.origin === 'CONTEXTE' ? '?' : ''
    return prefix + paramValue.textValue
  }
  if (paramValue.booleanValue) return paramValue.booleanValue ? 'vrai' : 'faux'
  if (paramValue.numberValue) return paramValue.numberValue
  if (paramValue.dateValue) return paramValue.dateValue
  if (paramValue.renvoieValue) {
    console.log('!!!!!!!!!!!!', paramValue.renvoieValue)
    const prefix = '#'
    const comp = paramValue.renvoieValue.component.replaceAll('.', '_')
    const customInputs = paramValue.renvoieValue.ids
      ? Object.entries(paramValue.renvoieValue.ids)
          .map(([k, v]) => k + '=' + v)
          .reduce((acc, curr) => acc + (acc ? ', ' : '') + curr, '')
      : ''
    const customSTR = customInputs ? '[' + customInputs + ']' : ''
    let cc = paramValue.renvoieValue.idcc
      ? paramValue.renvoieValue.idcc + '_'
      : paramValue.renvoieValue.theme
      ? `${currentCC}_`
      : ''
    let theme = paramValue.renvoieValue.theme
      ? paramValue.renvoieValue.theme + '_'
      : paramValue.renvoieValue.idcc
      ? `${curentTheme}_`
      : ''
    return prefix + cc + theme + comp + customSTR
  }
  if (paramValue.fonctionValue) {
    return getFonctionAsSTR(paramValue.fonctionValue)
  }
}

export function ParameterField({ param, classes, excludeFonctions, line, setParamValue, paramValue }) {
  const [tmpValue, setTmpValue] = useState('')
  const [anchorEl, setAnchorEl] = useState()
  const [dragPostion, setDragPosition] = useState()

  const currentCC = useSelector(state => state.conventionModule.conventionCollective.idcc)
  const curentTheme = useSelector(state => state.conventionModule.theme.nom)

  const open = Boolean(anchorEl)
  const valueAsText = useMemo(() => {
    return getValueAsString(paramValue, currentCC, curentTheme)
  }, [paramValue, currentCC, curentTheme])

  console.log('paramValue', paramValue)
  console.log('valueAsText', valueAsText)
  let handleSetParamValue = (nom, value) => {
    setParamValue(nom, value)
    setAnchorEl(null)
  }
  return (
    <>
      <Grid xs={12} style={{ cursor: 'pointer', marginTop: '5px', marginBottom: '5px' }}>
        <InputLabel id={'param_' + param.parametre.nom + '_label'}>{param.parametre.nom}</InputLabel>
        <Input
          disabled
          type="text"
          variant="filled"
          style={{ width: '100%' }}
          label={param.parametre.nom}
          startAdornment={
            <InputAdornment position="start">
              <IconButton
                size="small"
                aria-label="toggle password visibility"
                onClick={event => setAnchorEl(event.currentTarget)}
                style={{ marginRight: 5 }}
              >
                <Edit fontSize="small" />
              </IconButton>
              {valueAsText}
            </InputAdornment>
          }
        ></Input>
      </Grid>
      {open && (
        <Dialog
          open={open}
          onClose={() => setAnchorEl(null)}
          PaperComponent={PopoverDraggable}
          aria-labelledby="draggable-dialog-title"
        >
          {open && (
            <Paper className={classes.popper} elevation={1}>
              <ContainerTitle variant="h5" classes={classes} title={'Valeur de ' + param.parametre.nom} />
              <ParamDataPopperContent
                className={classes.formControl}
                classes={classes}
                param={param}
                excludeFonctions={excludeFonctions}
                line={line}
                onCancel={() => setAnchorEl(null)}
                setParamValue={handleSetParamValue}
                paramValue={paramValue}
              />
            </Paper>
          )}
        </Dialog>
      )}
    </>
  )
}
